import React from 'react';
import { TextLog } from 'modules/emergencies/components/ui/texts/LogText';
import { LogTitleContainer } from '../../ui/containers/logTitleContainer';
import LogIcon from 'modules/emergencies/components/log/LogIcon';

const TicketMovedLogTitle = ({ titleData = {}, title, icon }) => {
  const { hasSubtitle, log } = titleData;
  const agencyCode = log.action_object?.data?.agency_codes?.[0];
  return (
    <LogTitleContainer>
      <LogIcon icon={icon} />
      <TextLog color="#263340">{title}</TextLog>
      {hasSubtitle && <TextLog color="#54708C">/ Agency SAP: {agencyCode || '-'}</TextLog>}
    </LogTitleContainer>
  );
};

export default TicketMovedLogTitle;
